import { Coordinates } from "./coordinates.model";

export class ListSizeOverTime {
    name: string;
    data: Coordinates[];
    constructor() {
        this.name = "";
        this.data = [];
    }

}